// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1Y6Ae","imageUploader":"EGiftCard_imageUploader__1AmAd"};